<template>
    <v-card class="workspaces-list-container">
        <v-card-text class="workspace-card">
            <v-text-field
                style="padding: 0px 10px;"
                v-model="searchText"
                label="Search"
                clearable
                :append-icon="searchText ? 'mdi-close' : 'mdi-magnify'"
                @clear="clearSearch"
            />
            <div class="scrollable-list">
                <v-radio-group @change="setSelectedWorkspace" :value="selectedWorkspace">
                    <v-list v-if="!isLoading">
                        <v-list-item v-for="(item, index) in filteredWorkspaces" :key="index" style="border-bottom: 1px rgb(139, 137, 137) solid;">
                            <v-list-item-action>
                                <v-radio color="#67a0b4" :value="item" />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title class="list-item-title">{{ item.wp_label }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-progress-linear v-else :indeterminate="true" color="primary"/>
                </v-radio-group>
            </div>
        </v-card-text>
    </v-card>
</template>
  
<script>
    import { mapActions } from "vuex";
    export default {
        name: "WorkspacesList",
        props: {
            workspaces: {
                type: Array,
                required: true,
            },
            selectedWorkspace: {
                type: Object
            },
            isLoading: {
                type: Boolean
            }
        },
        data() {
            return {
                searchText: "",
            };
        },
        computed: {
            filteredWorkspaces() {
                return this.workspaces.filter((workspace) =>
                workspace.wp_label.toLowerCase().includes(this.searchText.toLowerCase())
                );
            },
        },
        methods: {
            ...mapActions(["fetchAllWorkspaces"]),
            clearSearch() {
                this.searchText = "";
            },
            setSelectedWorkspace(item){
                this.$emit('set-selected-workspace', item)
            }
        }
    };
</script>
<style scoped>
    .workspaces-list-container{
        width: 22%;
        height: 100%;
        margin-top: 15px;
    }
    .workspace-card{
        height: 100%;
        padding-bottom: 5px;
    }
    .scrollable-list {
        height: calc(100% - 54px);
        overflow-y: scroll;
        padding: 0px 10px;
    }
    .list-item-title{
        font-size: 12px;
    }
</style>
  


// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/WorkspacesList.vue